<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="项目" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['auditItems', validatorRules.auditItems]" :trigger-change="true" dictCode="inspection_base_Audit_items" placeholder="请选择项目"/>
        </a-form-item>
        <a-form-item label="细则" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'detailsRules', validatorRules.detailsRules]" placeholder="请输入细则"></a-input>
        </a-form-item>
        <a-form-item label="具体方针" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'specificPolicy', validatorRules.specificPolicy]" placeholder="请输入具体方针"></a-input>
        </a-form-item>
        <a-form-item label="严重程度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['severity', validatorRules.severity]" :trigger-change="true" dictCode="inspection_base_severity" placeholder="请选择严重程度"/>
        </a-form-item>
        <a-form-item label="分值" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'score', validatorRules.score]" placeholder="请输入分值"></a-input>
        </a-form-item>
        <a-form-item label="所属基地" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['baseNo', validatorRules.baseNo]" :trigger-change="true" dictCode="bus_inspection_base,base,base_no" placeholder="请选择所属基地"/>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['status', validatorRules.status]" :trigger-change="true" dictCode="on_off" placeholder="请选择状态"/>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  
  export default {
    name: "BusInspectionCheckModal",
    components: { 
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          auditItems: {rules: [
          ]},
          detailsRules: {rules: [
          ]},
          specificPolicy: {rules: [
          ]},
          severity: {rules: [
          ]},
          score: {rules: [
          ]},
          baseNo: {rules: [
            {required: true, message: '请输入所属基地!'},
          ]},
          status: {rules: [
            {required: true, message: '请输入状态!'},
          ]},
        },
        url: {
          add: "/busInspectionCheck/add",
          edit: "/busInspectionCheck/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'auditItems','detailsRules','specificPolicy','severity','score','baseNo','status'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'auditItems','detailsRules','specificPolicy','severity','score','baseNo','status'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>